import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { rv } from "../tokens";

const useStyles = makeStyles((theme) => ({
  wrap: {
    minHeight: 360,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    color: rv.muted,
  },
}));

export default function Loading() {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <CircularProgress style={{ color: rv.green }} />
      <span>{"Loading your details\u2026"}</span>
    </div>
  );
}
